import { Box, Typography } from "@mui/material";
import { GalerieCarousel } from "./components/carousel";

export function GaleriePage() {
  return (
    <Box>
      <Typography
        variant="h2"
        align="center"
        sx={{ mt: { xs: 4, md: 6 }, px: 2 }}
      >
        Nos compétitions
      </Typography>
      <GalerieCarousel />
    </Box>
  );
}
